var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    clipPath: "url(#clip0_2229_280)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.8 5.25H12.25V0H8.75V32.55C8.75 33.8975 9.85075 35 11.1965 35H23.8C25.1458 35 26.25 33.8958 26.25 32.55V7.70175C26.25 6.35075 25.1458 5.25 23.8 5.25ZM14 26.25C12.7908 26.25 11.8125 25.4677 11.8125 24.5C11.8125 23.5323 12.7908 22.75 14 22.75C15.2092 22.75 16.1875 23.5323 16.1875 24.5C16.1875 25.4677 15.2092 26.25 14 26.25ZM16.1875 29.75C16.1875 30.7177 15.2092 31.5 14 31.5C12.7908 31.5 11.8125 30.7177 11.8125 29.75C11.8125 28.7823 12.7908 28 14 28C15.2092 28 16.1875 28.7823 16.1875 29.75ZM12.25 19.25V8.75H22.75V19.25H12.25ZM21 26.25C19.7908 26.25 18.8125 25.4677 18.8125 24.5C18.8125 23.5323 19.7908 22.75 21 22.75C22.2092 22.75 23.1875 23.5323 23.1875 24.5C23.1875 25.4677 22.2092 26.25 21 26.25ZM23.1875 29.75C23.1875 30.7177 22.2092 31.5 21 31.5C19.7908 31.5 18.8125 30.7177 18.8125 29.75C18.8125 28.7823 19.7908 28 21 28C22.2092 28 23.1875 28.7823 23.1875 29.75Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2229_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.6346f210d3dfa94d5ff27857cd35a1bd.svg";
export { ForwardRef as ReactComponent };